import { Collapse } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import cx from 'classnames';
import React, { useCallback, useState } from 'react';
import { InvoiceList } from './invoice-list';
import { ManageSubscription } from './manage-subscription';
import { PaymentMethods } from './payment-methods';
import { appConfig } from 'config';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { requestUpgrade } from 'store/sagas/sagas';
import './billing-payments.css';
import { isSelfServiceAccount } from 'utils/billing';
const stripePromise = loadStripe(appConfig.stripePk);
export const BillingPayments = () => {
    const { state, dispatch, asyncDispatch } = useGlobalState();
    const [count, setCount] = useState(0);
    const [collapsibleOpen, setCollapsibleOpen] = useState(true);
    const [upgradeRequested, setUpgradeRequested] = useState(false);
    const [selection, setSelection] = useState('Essential');
    const toggleCollapsible = () => {
        setCollapsibleOpen(!collapsibleOpen);
    };
    const handleSelection = useCallback((event) => {
        setSelection(event.target.value);
    }, []);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!state.account) {
            return;
        }
        asyncDispatch(requestUpgrade(state.account.id, selection))
            .then(() => {
            setUpgradeRequested(true);
            dispatch(setMessages({
                value: `Your Upgrade Has Been Requested`,
                severity: 'success'
            }));
        })
            .catch(console.error);
    };
    return state.account ? (React.createElement("div", { className: "full-page" },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                padding: 5
            } },
            React.createElement("h1", { className: "g-page-name" }, "Your account"),
            React.createElement("div", { className: "billing-tabs-div" },
                React.createElement("div", { onClick: () => {
                        setCount(0);
                    }, style: {
                        display: 'flex',
                        width: '22%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderBottom: 'solid',
                        borderWidth: count === 0 ? '4px' : '2px',
                        borderColor: count === 0 ? '#635BFF' : 'inherit',
                        padding: '10px'
                    } },
                    React.createElement("span", { style: {
                            fontSize: '13px',
                            color: count === 0 ? '#635BFF' : 'inherit',
                            lineHeight: '18px',
                            fontWeight: 600
                        } }, "Subscription")),
                React.createElement("div", { onClick: () => {
                        setCount(1);
                    }, style: {
                        display: 'flex',
                        width: '22%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderBottom: 'solid',
                        borderWidth: count === 1 ? '4px' : '2px',
                        borderColor: count === 1 ? '#635BFF' : 'inherit',
                        padding: '10px'
                    } },
                    React.createElement("span", { style: {
                            fontSize: '13px',
                            color: count === 1 ? '#635BFF' : 'inherit',
                            lineHeight: '18px',
                            fontWeight: 600
                        } }, "Payment Methods")),
                React.createElement("div", { onClick: () => {
                        setCount(2);
                    }, style: {
                        display: 'flex',
                        width: '22%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderBottom: 'solid',
                        borderWidth: count === 2 ? '4px' : '2px',
                        borderColor: count === 2 ? '#635BFF' : 'inherit',
                        padding: '10px'
                    } },
                    React.createElement("span", { style: {
                            fontSize: '13px',
                            color: count === 2 ? '#635BFF' : 'inherit',
                            lineHeight: '18px',
                            fontWeight: 600
                        } }, "Invoices")),
                React.createElement("div", { onClick: () => {
                        setCount(3);
                    }, style: {
                        display: 'flex',
                        width: '22%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderBottom: 'solid',
                        borderWidth: count === 3 ? '4px' : '2px',
                        borderColor: count === 3 ? '#635BFF' : 'inherit',
                        padding: '10px'
                    } },
                    React.createElement("span", { style: {
                            fontSize: '13px',
                            color: count === 3 ? '#635BFF' : 'inherit',
                            lineHeight: '18px',
                            fontWeight: 600
                        } }, "Manage Subscription")),
                React.createElement("div", { onClick: () => {
                        setCount(4);
                    }, style: {
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderBottom: 'solid',
                        borderWidth: count === 4 ? '4px' : '2px',
                        borderColor: count === 4 ? '#635BFF' : 'inherit',
                        padding: '16px'
                    } })),
            count === 0 && (React.createElement("div", { className: "billing-container" },
                React.createElement("div", null,
                    React.createElement("div", null,
                        isSelfServiceAccount(state.account) && (React.createElement("div", { style: {
                                background: 'white',
                                borderRadius: '5px',
                                padding: '15px',
                                display: 'flex',
                                flexDirection: 'column',
                                marginBottom: '2vh'
                            } },
                            React.createElement("div", null,
                                React.createElement("span", { style: {
                                        fontWeight: 'bold',
                                        fontSize: '24px',
                                        color: '#444444',
                                        lineHeight: '28px'
                                    } }, "Base subscription")),
                            React.createElement("div", { style: {
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between'
                                } },
                                React.createElement("span", { style: {
                                        fontWeight: 'bold',
                                        fontSize: '24px',
                                        color: collapsibleOpen ? '#999999' : '#444444',
                                        lineHeight: '28px'
                                    } }, "$300/month"),
                                React.createElement("div", { onClick: toggleCollapsible },
                                    React.createElement("span", { style: {
                                            fontWeight: 'bold',
                                            fontSize: '16px',
                                            color: '#999999',
                                            lineHeight: '24px'
                                        } }, "What's included?"),
                                    React.createElement("i", { className: collapsibleOpen
                                            ? cx('fa fa-angle-up')
                                            : cx('fas fa-angle-down'), style: {
                                            color: '#999999',
                                            fontSize: '15px',
                                            padding: '0px 5px'
                                        } }))),
                            React.createElement(Collapse, { in: collapsibleOpen },
                                React.createElement("div", { style: { marginTop: '1vh' } },
                                    React.createElement("div", { style: { marginBottom: '2vh' } },
                                        React.createElement("span", { style: {
                                                fontWeight: 500,
                                                fontSize: '16px',
                                                lineHeight: '24px',
                                                color: '#444444'
                                            } }, "Verify and onboard new customers, patients, partners and gig contractors in seconds. With Vouched ID verification, you can expand your reach while keeping the bad guys out.")),
                                    React.createElement("div", { style: {
                                            padding: '10px 0px',
                                            borderTop: 'solid 1px #eeeeee'
                                        } }),
                                    React.createElement("div", null,
                                        React.createElement("div", { style: { marginBottom: '2vh' } },
                                            React.createElement("span", { style: {
                                                    fontWeight: 800,
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                    color: '#999999'
                                                } }, "Included features")),
                                        React.createElement("div", { style: {
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            } },
                                            React.createElement("div", { style: {
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                } },
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Expert ID Document Examination"),
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Facial Recognition, Liveness Detection"),
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Data Extraction"),
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Dashboard Access")),
                                            React.createElement("div", { style: {
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                } },
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Anonymous Activity"),
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Analysis of email, phone, address, name"),
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Email age and fraud risk"),
                                                React.createElement("div", { style: {
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        lineHeight: '24px',
                                                        color: '#444444'
                                                    } }, "Phone source")))))),
                            React.createElement("h3", null, "Request Account Upgrade"),
                            upgradeRequested ? (React.createElement("p", null, "Request received! Our compliance team will evaluate your request and we'll be in touch soon. Please email support@vouched.id with any questions.")) : (React.createElement("form", { id: "account-upgrade-form", onSubmit: handleSubmit },
                                React.createElement("label", { htmlFor: "package" }, " Upgrade to: "),
                                React.createElement("select", { id: "package", name: "package", onChange: handleSelection, value: selection },
                                    React.createElement("option", { value: "Essential" }, "Essential "),
                                    React.createElement("option", { value: "Advanced" }, "Advanced "),
                                    React.createElement("option", { value: "Premier" }, "Premier ")),
                                React.createElement("button", { className: "upgrade-button", form: "account-upgrade-form", type: "submit", value: "Submit" }, "Request"))),
                            React.createElement("p", null,
                                "View our packages",
                                ' ',
                                React.createElement("a", { href: "https://www.vouched.id/for-developers/pricing/", rel: "noreferrer", target: "_blank" }, "here")))),
                        !isSelfServiceAccount(state.account) && (React.createElement("div", { style: {
                                fontWeight: 500,
                                fontSize: '16px',
                                lineHeight: '24px',
                                color: '#444444',
                                marginBottom: '2vh'
                            } }, "Your subscription is managed by the Vouched team. Please reach out to support if you have any questions!")))))),
            count === 1 && (React.createElement("div", { className: "billing-container" },
                React.createElement(Elements, { stripe: stripePromise },
                    React.createElement(PaymentMethods, null)))),
            count === 2 && React.createElement(InvoiceList, null),
            count === 3 && (React.createElement("div", null,
                React.createElement(ManageSubscription, null)))))) : (React.createElement("div", { className: "billing-unavailable" }, "This page is unavailable because your billing is being managed by the Vouched team. Reach out to support to ask about getting set up with automatic billing"));
};
